"use client";
import React from "react";
import SwiperSlider from "../test-slider/SwiperSlider";
import "./faculty.css";

const FacultySection = () => {
  return (
    <section className="faculty-section py-20">
      {/* Background Blobs for depth */}
      <div className="decorative-blob blob-1"></div>
      <div className="decorative-blob blob-2"></div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-3 mb-4">
            <span className="h-[2px] w-8 bg-blue-600"></span>
            <span className="text-blue-600 font-bold text-xs uppercase tracking-widest">Our Faculty</span>
            <span className="h-[2px] w-8 bg-blue-600"></span>
          </div>
          
          <h2 className="text-4xl md:text-6xl font-black text-slate-900 mb-6 tracking-tight">
            Learn from the <span className="text-glow-blue">Best.</span>
          </h2>
          
          <p className="text-slate-500 max-w-2xl mx-auto text-lg">
            Industry experts dedicated to bridging the gap between education and your professional success.
          </p>
        </div>

        <SwiperSlider />
      </div>
    </section>
  );
};

export default FacultySection;